import { ApiProperty } from "@nestjs/swagger";


export class MessageRequest {
    @ApiProperty()
    messageCode: number;
    @ApiProperty()
    message?: string;
    @ApiProperty()
    receivers?: string[];
    
    /**
     * 
     * @param messageCode 
     * @param message 
     */
    constructor(messageCode: number, message: string,receivers?: string[]) {
       this.messageCode = messageCode;
       this.message = message;
       this.receivers = receivers;
    }
}